"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LyricCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Shows song lyrics at the bottom of the screen until the next #LYRIC command.
 * Line breaks can be added with `\n`. Has to be repeated for each difficulty.
 * Can be placed in the middle of a measure. If `LYRICS` is defined in the
 * song metadata, this will be ignored.
 *
 * **Example:**
 *
 * ```
 * #LYRIC ケロッ！ケロッ！ケロッ！いざ進め〜ッ
 * ```
 */
class LyricCommand extends Command_1.Command {
    constructor(line) {
        super(CommandType_1.CommandType.Lyric);
        this.line = line;
    }
    static parse(args) {
        return new LyricCommand(args.join(' '));
    }
    toString() {
        return `${super.toString()} ${this.line}`;
    }
}
exports.LyricCommand = LyricCommand;
